var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnegate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33277 1.17056L11.8857 2.2262L11.7113 2.64747L9.15831 1.59184L9.33277 1.17056Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19896 0.847141L12.21 2.09216L11.846 2.97112L8.83497 1.72609L9.19896 0.847141Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16171 0.759781L12.2979 2.05591L11.8823 3.05975L8.7462 1.76363L9.16171 0.759781Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0174 3.38261L12.6201 1.91918L9.02917 0.433228L8.42082 1.89385L12.0174 3.38261ZM11.9723 2.18654L11.747 2.73251L9.07141 1.62649L9.29673 1.08052L11.9723 2.18654Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15544 0.743889L12.3096 2.0481L11.8864 3.07007L8.73222 1.76587L9.15544 0.743889Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.023 3.39342L12.6201 1.91309L9.02353 0.418701L8.39547 1.89902L12.023 3.39342ZM11.9864 2.18327L11.7527 2.74613L9.05733 1.62041L9.29109 1.05755L11.9864 2.18327Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0571 3.48405L12.7246 1.87708L8.98721 0.332031L8.32253 1.93618L12.0571 3.48405ZM11.8994 2.22043L11.7163 2.65946L9.14774 1.59565L9.32799 1.15662L11.8994 2.22043Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1922 3.80834L13.0371 1.74264L8.85189 0.0090332L8.00696 2.07191L12.1922 3.80834ZM12.3978 2.01281L11.9246 3.15823L8.64629 1.80456L9.11945 0.656322L12.3978 2.01281ZM11.8514 2.98375L12.2232 2.08599L9.1955 0.833623L8.82091 1.73138L11.8514 2.98375Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7791 4.10808L14.8369 6.65857L14.4154 6.83311L13.3576 4.28263L13.7791 4.10808Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9492 3.78169L15.1875 6.77734L14.3117 7.13881L13.0734 4.14316L13.9492 3.78169Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9497 3.69954L15.249 6.8324L14.2447 7.24829L12.9454 4.11543L13.9497 3.69954Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1097 7.5699L15.5742 6.96483L14.0843 3.37378L12.6198 3.97885L14.1097 7.5699ZM14.9264 6.69747L14.3801 6.92261L13.2704 4.24903L13.8168 4.03233L14.9264 6.69747Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9568 3.68683L15.2637 6.83789L14.2411 7.26132L12.9343 4.11026L13.9568 3.68683Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 7.58436L15.5889 6.97085L14.0905 3.36292L12.6203 3.97643L14.1074 7.58436ZM14.9383 6.70349L14.375 6.93707L13.2484 4.24379L13.8117 4.0102L14.9383 6.70349Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0704 7.67146L15.6758 7.00728L14.1267 3.27271L12.5214 3.93969L14.0704 7.67146ZM14.8506 6.66675L14.4112 6.84687L13.3466 4.28022L13.786 4.09729L14.8506 6.66675Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9356 7.99562L16 7.14289L14.2623 2.94958L12.1978 3.79387L13.9356 7.99562ZM15.3438 6.8699L14.1947 7.34552L12.8456 4.07249L13.9919 3.59687L15.3438 6.8699ZM14.2679 7.16822L15.1748 6.79955L13.9215 3.77417L13.023 4.14566L14.2679 7.16822Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21906 4.12956L2.64062 4.30396L1.58375 6.85481L1.16219 6.68041L2.21906 4.12956Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0862 3.80621L2.96582 4.16992L1.71985 7.17864L0.840237 6.81493L2.0862 3.80621Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04925 3.71459L3.05371 4.13013L1.75551 7.26344L0.751046 6.8479L2.04925 3.71459Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88988 7.59029L3.37695 3.99643L1.91804 3.39136L0.425333 6.98522L1.88988 7.59029ZM2.73481 4.2666L1.62513 6.94019L1.07874 6.71505L2.17997 4.03302L2.73481 4.2666Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04178 3.70266L3.06445 4.12573L1.75871 7.27725L0.736031 6.85417L2.04178 3.70266Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89217 7.60194L3.3877 3.99401L1.91752 3.38049L0.410728 6.98842L1.89217 7.60194ZM2.7371 4.26137L1.61053 6.95465L1.04724 6.72107L2.17381 4.02778L2.7371 4.26137Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91776 7.69185L3.4668 3.95727L1.85861 3.29028L0.312393 7.02486L1.91776 7.69185ZM2.65285 4.2978L1.58824 6.86726L1.14887 6.68433L2.1994 4.11487L2.65285 4.2978Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.065 8.01575L3.80273 3.82244L1.73547 2.97815L0.00055182 7.17146L2.065 8.01575ZM3.15214 4.0898L1.79744 7.36564L0.648332 6.89284L2.00585 3.617L3.15214 4.0898ZM1.72421 7.18553L2.97752 4.16297L2.07908 3.79148L0.825766 6.81967L1.72421 7.18553Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65247 1.16939L6.82715 1.59058L4.27473 2.64754L4.10005 2.22636L6.65247 1.16939Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78887 0.845116L7.15332 1.72388L4.14297 2.97047L3.77852 2.09171L6.78887 0.845116Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.825 0.756576L7.24121 1.76013L4.10598 3.05845L3.68977 2.05489L6.825 0.756576Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96828 3.38261L7.55078 1.89385L6.94525 0.433228L3.36275 1.92199L3.96828 3.38261ZM6.91427 1.62649L4.23866 2.73532L4.01053 2.18935L6.68895 1.08052L6.91427 1.62649Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82918 0.742649L7.25293 1.7644L4.09948 3.07026L3.67573 2.04851L6.82918 0.742649Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96551 3.39623L7.57617 1.89902L6.96219 0.418701L3.35152 1.91591L3.96551 3.39623ZM6.92839 1.63166L4.23307 2.75738L3.9993 2.19452L6.69463 1.0688L6.92839 1.63166Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9285 3.48405L7.66309 1.93618L6.98714 0.332031L3.24974 1.8799L3.9285 3.48405ZM6.83787 1.59565L4.26929 2.65946L4.08622 2.22043L6.65762 1.15662L6.83787 1.59565Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79364 3.80775L7.9873 2.06288L7.14238 0L2.94589 1.73642L3.79364 3.80775ZM7.33953 1.80397L4.0612 3.16046L3.58522 2.01222L6.86355 0.655732L7.33953 1.80397ZM4.13443 2.98316L7.16209 1.73079L6.79032 0.833033L3.76266 2.0854L4.13443 2.98316Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28785 13.3611L6.84082 14.4167L6.66636 14.838L4.11339 13.7824L4.28785 13.3611Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15013 13.0374L7.16113 14.2825L6.79714 15.1614L3.78614 13.9164L4.15013 13.0374Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11581 12.9492L7.25195 14.2454L6.83645 15.2492L3.70031 13.9531L4.11581 12.9492Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96978 15.5721L7.57812 14.1086L3.98154 12.6227L3.37601 14.0861L6.96978 15.5721ZM6.92753 14.3788L6.70222 14.9248L4.02379 13.8159L4.25192 13.27L6.92753 14.3788Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11345 12.9357L7.26758 14.2399L6.84436 15.2618L3.69023 13.9576L4.11345 12.9357Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98758 15.5853L7.60156 14.105L3.98808 12.6106L3.37691 14.0937L6.98758 15.5853ZM6.95378 14.3752L6.72002 14.938L4.02469 13.8123L4.25846 13.2494L6.95378 14.3752Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93935 12.5238L3.27468 14.1308L7.01208 15.6758L7.67676 14.0689L3.93935 12.5238ZM4.09989 13.7874L4.28296 13.3484L6.85154 14.4122L6.67129 14.8512L4.09989 13.7874Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14823 15.9999L7.99316 13.937L3.80795 12.1949L2.96302 14.2578L7.14823 15.9999ZM7.35383 14.2044L6.87786 15.3526L3.60798 13.9961L4.08396 12.8479L7.35383 14.2044ZM6.80463 15.1753L7.1764 14.2775L4.14873 13.0392L3.77697 13.937L6.80463 15.1753Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58383 9.16948L2.6416 11.72L2.2201 11.8945L1.16233 9.34403L1.58383 9.16948Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71437 8.84618L2.96191 11.8542L2.08249 12.2184L0.834945 9.21036L1.71437 8.84618Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75148 8.75776L3.05078 11.8906L2.04647 12.3065L0.747167 9.17366L1.75148 8.75776Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91804 12.6333L3.37695 12.0254L1.88706 8.43433L0.425333 9.04221L1.91804 12.6333ZM2.73199 11.758L2.1856 11.9832L1.07311 9.30957L1.6195 9.08161L2.73199 11.758Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75858 8.74579L3.06543 11.8969L2.0429 12.3203L0.736055 9.16922L1.75858 8.74579Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91699 12.6445L3.39844 12.031L1.89165 8.4231L0.410205 9.03661L1.91699 12.6445ZM2.76192 11.7637L2.19864 11.9973L1.07207 9.30397L1.63535 9.07039L2.76192 11.7637Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91776 8.33325L0.312393 9.00024L1.86143 12.732L3.4668 12.0678L1.91776 8.33325ZM1.13761 9.34077L1.57697 9.15784L2.64158 11.7273L2.1994 11.913L1.13761 9.34077Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73829 13.0583L3.80273 12.2141L2.065 8.02075L0.00055182 8.86504L1.73829 13.0583ZM3.14651 11.9326L1.9974 12.4082L0.639882 9.1324L1.78899 8.6596L3.14651 11.9326ZM2.07063 12.2338L2.96907 11.8595L1.71576 8.83409L0.817317 9.20557L2.07063 12.2338Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4523 9.11508L14.8721 9.28833L13.8222 11.8283L13.4024 11.655L14.4523 9.11508Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2826 8.82876L15.1621 9.19263L13.9156 12.2011L13.0361 11.8373L14.2826 8.82876Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2455 8.74071L15.25 9.15625L13.9518 12.2896L12.9473 11.874L14.2455 8.74071Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0871 12.6137L15.5742 9.02268L14.1097 8.4176L12.6198 12.0086L14.0871 12.6137ZM14.9321 9.29285L13.8224 11.9664L13.276 11.7413L14.3801 9.06489L14.9321 9.29285Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.241 8.73L15.2637 9.15308L13.9579 12.3046L12.9352 11.8815L14.241 8.73Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0933 12.6281L15.5889 9.01732L14.1074 8.40662L12.6203 12.0145L14.0933 12.6281ZM14.9383 9.28749L13.8117 11.9808L13.2484 11.7472L14.375 9.0539L14.9383 9.28749Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0704 8.31641L12.5214 12.051L14.1296 12.7152L15.6758 8.98058L14.0704 8.31641ZM13.3466 11.7105L14.4112 9.141L14.8506 9.32392L13.786 11.8906L13.3466 11.7105Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2623 13.0391L16 8.84856L13.9356 8.00427L12.1978 12.1948L14.2623 13.0391ZM15.3522 9.11592L13.9947 12.3918L12.8456 11.9133L14.2031 8.6403L15.3522 9.11592ZM13.9215 12.2117L15.1748 9.18909L14.2763 8.8176L13.023 11.843L13.9215 12.2117Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7257 13.3581L11.9004 13.7793L9.34797 14.8363L9.17329 14.4151L11.7257 13.3581Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8592 13.0346L12.2236 13.9133L9.21329 15.1599L8.84884 14.2812L11.8592 13.0346Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8963 12.946L12.3125 13.9496L9.17726 15.2479L8.76106 14.2443L11.8963 12.946Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04295 15.5721L12.6367 14.0861L12.0284 12.6227L8.4346 14.1114L9.04295 15.5721ZM11.9889 13.8188L9.31051 14.9276L9.0852 14.3816L11.7608 13.2728L11.9889 13.8188Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9005 12.9353L12.3242 13.957L9.17077 15.2629L8.74701 14.2411L11.9005 12.9353Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03777 15.5853L12.6484 14.0909L12.0345 12.6106L8.42379 14.105L9.03777 15.5853ZM12.0007 13.8236L9.30533 14.9493L9.07157 14.3864L11.7669 13.2607L12.0007 13.8236Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0571 12.5238L8.32253 14.0689L8.98721 15.6758L12.7246 14.128L12.0571 12.5238ZM9.14774 14.4122L11.7304 13.3484L11.9135 13.7874L9.34208 14.8512L9.14774 14.4122Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86602 15.9997L13.0625 14.2633L12.2176 12.2004L8.02109 13.9369L8.86602 15.9997ZM12.4119 13.9931L9.13639 15.3525L8.66042 14.2042L11.9359 12.8477L12.4119 13.9931ZM9.20962 15.1752L12.2373 13.92L11.8655 13.0391L8.83504 14.2774L9.20962 15.1752Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnegate);
export default __webpack_public_path__ + "static/media/onegate.f04857561104ee5bd19850a9e16047fa.svg";
export { ForwardRef as ReactComponent };